<!--
  Created 09.10.2023
  Navbar component for the proposal show page.
-->
<template>
  <div>
    <nav
      class="isolate flex h-full items-stretch divide-x divide-gray-200 rounded-lg shadow"
      aria-label="Tabs">
      <a
        v-for="(item, itemIdx) in navItems.filter((item) => item.visible)"
        :key="item.title"
        :href="item.component"
        :class="[item.current ? 'text-purple-950' : 'text-gray-900 hover:text-purple-900',
                 itemIdx === 0 ? 'rounded-l-lg' : '',
                 itemIdx === navItems.length - 1 ? 'rounded-r-lg' : '',
                 'text-md group relative flex min-w-0 flex-1 items-center justify-center space-x-2 overflow-hidden bg-white p-4 text-center font-medium hover:bg-gray-50 focus:z-10']"
        :aria-current="item.current ? 'page' : undefined"
        @click.prevent="$emit('scrollIntoView', { component: item.component })">
        <component
          :is="icons[item.icon]"
          v-if="item.icon"
          :class="[item.class, 'h-6 w-6']"
          aria-hidden="true" />
        <span>{{ item.title }}</span>
        <span
          aria-hidden="true"
          :class="[item.current ? 'bg-purple-800' : 'bg-transparent',
                   'absolute inset-x-0 bottom-0 h-0.5']" />
      </a>
    </nav>
  </div>
</template>

<script setup>
import {
  GlobeEuropeAfricaIcon, PaperAirplaneIcon, HomeIcon, CalendarDaysIcon, ShoppingBagIcon, ChevronDoubleDownIcon,
} from '@heroicons/vue/24/outline';

defineEmits(['scrollIntoView']);

const icons = {
  GlobeEuropeAfricaIcon,
  PaperAirplaneIcon,
  HomeIcon,
  CalendarDaysIcon,
  ShoppingBagIcon,
  ChevronDoubleDownIcon,
};

defineProps({
  navItems: {
    type: Array,
    required: false,
    default: () => [{}],
  },
});
</script>
